import PropTypes from "prop-types";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import newsearchfilter from "app/Search/Header/searchFilterNew/SearchFilterNew.scss";
import customFilter from "../CustomFilterModal.scss";

import FilterSearchBar from "app/Search/Header/searchFilterNew/FloatingSearchBar";
import { useActiveSection } from "./ActiveSectionContext";
import { LeadList } from "./right/LeadList";
import LiensBankruptcy from "./right/LiensBankruptcy";
import MLSscreen from "./right/MLS";
import MortgageInfo from "./right/MortgageInfo";
import OwnerInformationOccupancy from "./right/OwnerInformationOccupancy";
import PreForeclosureBank from "./right/PreForeclosureBank";
import PropertyDetails from "./right/PropertyDetails";
import ValueEquityScreen from "./right/ValueEquity";
import PropstreamIntelligenceScreen from "./right/PropstreamIntelligence";

/*
 * Copy of app/Search/Header/searchFilterNew/panel/RightPanel.js adapted for the
 * CustomFilterModal: the location SuggestedInput machinery (imported but never
 * rendered on the Search page) is removed, the sections are the local copies
 * wired to the modal's private filter store, and the scroll container height is
 * overridden to fit inside the modal.
 */
export const RightPanel = ({ selectedIndex, hotkeysEnabled }) => {
  const components = [
    LeadList,
    PropertyDetails,
    PropstreamIntelligenceScreen,
    MLSscreen,
    PreForeclosureBank,
    OwnerInformationOccupancy,
    LiensBankruptcy,
    ValueEquityScreen,
    MortgageInfo
  ];
  const { setActiveSection } = useActiveSection();
  const containerRef = useRef(null);
  const [isInputClickedOrTagSelected, setIsInputClickedOrTagSelected] = useState(false);
  const [autoScroll, setAutoScroll] = useState(false);

  const timeoutRef = useRef(null); // Store timeout ID

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container) return;

    const containerTop = container.getBoundingClientRect().top;

    const sectionIndexes = components.map((_, index) => {
      const ref = refsArray[index].current;
      if (ref) {
        const rect = ref.getBoundingClientRect();
        return {
          index,
          top: rect.top - containerTop,
          bottom: rect.bottom - containerTop
        };
      }
      return null;
    });

    const visibleSections = sectionIndexes.filter(({ top, bottom }) => {
      return top <= container.clientHeight && bottom > 100;
    });

    if (visibleSections.length > 0 && !autoScroll) {
      setActiveSection(visibleSections[0].index);
    }
  };

  useEffect(() => {
    handleScroll();
  }, []);

  const refsArray = components.map(() => useRef(null));

  const scrollToSection = () => {
    const selectedRef = refsArray[selectedIndex].current;
    const container = containerRef.current;

    if (selectedRef && container) {
      const containerRect = container.getBoundingClientRect();
      const selectedRect = selectedRef.getBoundingClientRect();
      const scrollTopValue =
        selectedRect.top - containerRect.top + container.scrollTop;

      setAutoScroll(true);

      container.scrollTo({
        top: scrollTopValue,
        behavior: "smooth"
      });

      if (timeoutRef?.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setAutoScroll(false);
      }, 800); // Adjust timeout duration based on scroll speed
    }
  };

  useEffect(() => {
    scrollToSection();
  }, [selectedIndex]);

  return (
    <div className={classNames(newsearchfilter.clsRightBodyScroll, customFilter.rightBodyScrollHeight)} ref={containerRef} onScroll={handleScroll}>
      <div ref={refsArray[0]}>
        <div className={isInputClickedOrTagSelected ? newsearchfilter.dropdownTagHeader : newsearchfilter.dropdownTagHeaderRight}>
          <div className={newsearchfilter.clsTopHeader}>
            <FilterSearchBar setIsInputClickedOrTagSelected={setIsInputClickedOrTagSelected} hotkeysEnabled={hotkeysEnabled} />
          </div>
        </div>
        <div className={newsearchfilter.topPadding}>
          <LeadList />
        </div>
      </div>
      <div ref={refsArray[1]}>
        <PropertyDetails />
      </div>
      <div ref={refsArray[2]}>
        <PropstreamIntelligenceScreen />
      </div>
      <div ref={refsArray[3]}>
        <MLSscreen />
      </div>
      <div ref={refsArray[4]}>
        <PreForeclosureBank />
      </div>
      <div ref={refsArray[5]}>
        <OwnerInformationOccupancy />
      </div>
      <div ref={refsArray[6]}>
        <LiensBankruptcy />
      </div>
      <div ref={refsArray[7]}>
        <ValueEquityScreen />
      </div>
      <div ref={refsArray[8]}>
        <MortgageInfo />
      </div>
    </div>
  );
};

RightPanel.propTypes = {
  selectedIndex: PropTypes.number.isRequired,
  hotkeysEnabled: PropTypes.bool
};
